import React, { Suspense } from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useOnClose } from 'js/components/common/PopupManager/hooks';
import { useSubscribeOnLocationChange } from 'js/hooks/useSubscribeOnLocationChange';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import { QuickDeposit } from 'js/components/main/QuickDeposit/QuickDeposit';

import style from './QuickDepositPopup.scss';

export const QuickDepositPopup = ({ id, onClose }) => {
    const onClosePopup = useOnClose(id);
    const navigateToPopupBackgroundPage = useNavigateToPopupBackgroundPage();
    const combinedClose = useCombinedHandler([onClosePopup, onClose || navigateToPopupBackgroundPage]);

    useSubscribeOnLocationChange(onClosePopup);

    return (
        <ManagedPopup
            id={id}
            className={style.popup}
            onClose={combinedClose}
            layerClassNames={style}
        >
            <Suspense fallback="">
                <QuickDeposit afterSuccessDeposit={combinedClose} />
            </Suspense>
        </ManagedPopup>
    );
};
